import TooltipV2 from '@/components/Tooltip/TooltipV2';
import { Span } from '@/components/Typography';
import {
  type SCRAPING_JOB_DISPLAY_STATUS,
  type SCRAPING_SCHEDULE_DISPLAY_STATUS,
  ScrapingDisplayStatusMap,
} from '@/features/Scraping/types';

export const JobStatus = (props: {
  status: SCRAPING_JOB_DISPLAY_STATUS | SCRAPING_SCHEDULE_DISPLAY_STATUS;
}) => {
  const { status } = props;
  const value = ScrapingDisplayStatusMap.get(status);
  if (!value) return null;

  return (
    <TooltipV2 tooltipNode={value.tooltip} key={status}>
      <div className="flex gap-1 items-center">
        {value.icon}
        <Span size={3} weight="r">
          {value.text}
        </Span>
      </div>
    </TooltipV2>
  );
};
